import React, {Component} from 'react';
import styles from './index.css';

class Drag extends Component {
    state = {dropStart: false};

    setDropStart() {
        this.setState({dropStart: !this.state.dropStart});
    }

    Drag(e, callback = () => {}) {
        if(this.props.onDrag) this.props.onDrag();
        const touch = !!e.touches;
        let x, y;
        const Emilia = e.target;
        const elem = touch ? e.touches[0] : e;
        let shiftX = elem.pageX - Emilia.getBoundingClientRect().left;
        let shiftY = elem.pageY - Emilia.getBoundingClientRect().top;

        const dragTags = Emilia.getAttribute("data-dragtype").split(',');
        let drops = [];
        dragTags.forEach((item)=>{
            drops = drops.concat(...document.querySelectorAll(
                `div[data-droptype="${item}"]`));
        });


        const drags = document.querySelectorAll(
            `div[data-dragtype]`,
        );

        drags.forEach(item=>{
            item.style.pointerEvents = 'none'
        });

        drops.forEach(item => {
            item.style.opacity = null;
            item.style.pointerEvents = 'inherit';
        });

        Emilia.style.position = 'fixed';
        Emilia.style.pointerEvents = 'none';
        Emilia.style.zIndex = 250;

        const moveAt = e => {
            let elem = e.touches ? e.touches[0] : e;
            x=elem.pageX; y=elem.pageY;
            Emilia.style.left = x - shiftX + 'px';
            Emilia.style.top = y - shiftY + 'px';
        };

        const MouseUp = () => {
            Emilia.style.position = Emilia.style.left = Emilia.style.top = Emilia.style.pointerEvents = null;
            this.setDropStart();
            if (touch) {
                window.removeEventListener('touchmove', moveAt, false);
                window.removeEventListener('touchend', MouseUp, false);
            } else {
                window.onmousemove = null;
                window.onmouseup = null;
            }
            let deepEqual = false;
            dragTags.forEach((item)=>{
                if(document.elementFromPoint(x, y) && item === document
                    .elementFromPoint(x, y)
                    .getAttribute('data-droptype')){deepEqual = true}
            });
            if (deepEqual) {
                if (this.props.onDrop) this.props.onDrop();
                document
                    .elementFromPoint(x , y,)
                    .click();
            }
            drops.forEach(item => {
                item.style.opacity = 0;
                item.style.pointerEvents = 'none';
                Emilia.style.zIndex = "inherit";
            });
            drags.forEach(item=>{
                item.style.pointerEvents = 'inherit'
            });
            callback();
        };

        moveAt(elem);

        if (touch) {
            window.addEventListener('touchmove', moveAt, false);
            window.addEventListener('touchend', MouseUp, false);
        } else {
            window.onmousemove = moveAt;
            window.onmouseup = MouseUp;
        }
    }

    render() {
        return (
            <div style={this.props.style ? this.props.style : null}>
                {this.state.dropStart && this.props.maskClassName ? (
                    <div className={this.props.maskClassName} />
                ) : null}
                <div
                    onMouseOver={this.props.onMouseOver}
                    style={this.props.style ? this.props.style : null}
                    data-dragtype={this.props.type}
                    className={styles.dragElement}
                    onTouchStart={e => {
                        this.setState({dropStart: true});
                        e.preventDefault();
                        this.Drag(e);
                    }}
                    onMouseDown={e => {
                        e.stopPropagation()
                        this.setState({dropStart: true});
                        e.preventDefault();
                        this.Drag(e);
                    }}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Drag;


// WEBPACK FOOTER //
// ./src/shared/components/DragNDrop/Drag/index.js